var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.t("loan.total_amount")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t("loan.total_amount", {}, "zh"),
                fieldname: "amount",
                name: "amount",
                required: "",
                value: _vm.$store.state.form.applicantInfo.amount,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("lead.question_reason"))),
            ]),
            _vm._v(" "),
            _c("v-select", {
              attrs: {
                options: _vm.reasonOptions,
                reduce: (option) => option.code,
                searchable: false,
                fieldTitle: _vm.t("lead.question_reason", {}, "zh"),
                fieldValue: _vm.selectedReason,
                fieldname: "reason",
                name: "reason",
                required: "",
              },
              model: {
                value: _vm.selectedReason,
                callback: function ($$v) {
                  _vm.selectedReason = $$v
                },
                expression: "selectedReason",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
          _c("label", { staticClass: "inbox-label required" }, [
            _vm._v(_vm._s(_vm.t("lead.company_name"))),
          ]),
          _vm._v(" "),
          _c("input", {
            staticClass: "form-control",
            attrs: {
              fieldTitle: _vm.t("lead.company_name", {}, "zh"),
              fieldname: "companyName",
              type: "text",
              required: "",
              name: "companyName",
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("lead.industry"))),
            ]),
            _vm._v(" "),
            _c("v-select", {
              attrs: {
                options: _vm.industries,
                fieldValue: _vm.selectedIndustry,
                reduce: (option) => option.code,
                searchable: false,
                fieldTitle: _vm.t("lead.industry", {}, "zh"),
                fieldname: "industry",
                label: "name",
                required: "",
              },
              model: {
                value: _vm.selectedIndustry,
                callback: function ($$v) {
                  _vm.selectedIndustry = $$v
                },
                expression: "selectedIndustry",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("application.annual_sales_turnover"))),
            ]),
            _vm._v(" "),
            _c("MoneyInput", {
              attrs: {
                fieldTitle: _vm.t(
                  "application.annual_sales_turnover",
                  {},
                  "zh"
                ),
                fieldname: "turnover",
                name: "turnover",
                value: "",
                required: "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("lead.operation_years"))),
            ]),
            _vm._v(" "),
            _c("IntegerInput", {
              attrs: {
                fieldTitle: _vm.t("lead.operation_years", {}, "zh"),
                label: _vm.t("common.year_unit"),
                fieldname: "operationYears",
                required: "",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }